import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SharedUiEmailModule } from '@se-po/shared-ui-email'
import { SharedUiPersonaAvatarModule } from '@se-po/shared-ui-persona-avatar'
import { SharedUiPhoneModule } from '@se-po/shared-ui-phone'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeChipModule } from 'se-fe-chip'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeFormFieldTextModule } from 'se-fe-form-field-text'
import { SeFeGridModule } from 'se-fe-grid'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFeIconModule, seFeIconEnvelopeFilled, seFeIconPhoneFill, seFeIconPlusCircleOutline } from 'se-fe-icon'
import { SeFeTranslationsModule } from 'se-fe-translations'
import { ChildContactInfoComponent } from './child-contact-info/child-contact-info.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeCardModule,
    SeFeChipModule,
    SeFeFormFieldModule,
    SeFeFormFieldTextModule,
    SeFeGridModule,
    SeFeHeaderModule,
    SeFeIconModule.include([
      seFeIconEnvelopeFilled,
      seFeIconPhoneFill,
      seFeIconPlusCircleOutline
    ]),
    SeFeTranslationsModule,
    SharedUiEmailModule,
    SharedUiPhoneModule,
    SharedUiPersonaAvatarModule

  ],
  declarations: [
    ChildContactInfoComponent
  ],
  exports: [
    ChildContactInfoComponent
  ]
})
export class SharedUiChildContactInfoModule {}
